import { forwardRef } from 'react';
import { BaseIcon } from '@components/Icon/BaseIcon';
import type { IconProps } from '@components/Icon/Icon';

export type CloseIconProps = Omit<IconProps, 'icon' | 'size'> & {
  size?: 's' | 'm';
};

const SIZES = {
  s: 12,
  m: 16,
};

export const CloseIcon = forwardRef<SVGSVGElement, CloseIconProps>(
  ({ size = 'm', ...props }: CloseIconProps, ref): JSX.Element => (
    <BaseIcon {...props} pixelSize={SIZES[size]} ref={ref} icon="close" />
  ),
);

CloseIcon.displayName = 'CloseIcon';
